<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item >
              <span slot="label">
                项 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目
              </span>
              <a-select
                allowClear
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item>
              <span slot="label">
                日 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;期
              </span>
              <a-range-picker
                style="max-width: 200px;min-width: 100%"
                @change="onChange"
                v-model="clearDate"/>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="6" :md="6" :sm="24">
            <a-form-item label="客户名称">
              <a-input
                :disabled="showable"
                placeholder="请输入客户名称"
                v-model="queryParam.customerName"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="机械类别">
              <a-input
                :disabled="showable"
                placeholder="请输入机械类别"
                v-model="queryParam.type"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="审计确认">
              <a-select v-model="queryParam.audit" placeholder="请选择" allowClear>
                <a-select-option value="0">未确认</a-select-option>
                <a-select-option value="1">已确认</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="财务确认">
              <a-select v-model="queryParam.isAmount" placeholder="请选择" allowClear>
                <a-select-option value="0">未确认</a-select-option>
                <a-select-option value="1">已确认</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="table-operator">
        <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
        <a-button @click="() => {queryParam = {},clearDate=undefined,queryParam.isSum=true}" >重置</a-button>
      </div>
      <div class="table-operator">
        <a-button type="primary" icon="download" @click="download">Excel导出</a-button>
      </div>
    </div>
    <s-table
      :isInquire="false"
      bordered
      disabled="showable"
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
      <span slot="audit" slot-scope="text,record">
        <span v-if="String(text) === '1'">
          <!--          <a-tag color="#108ee9">已确认</a-tag>-->
          <span v-if="$auth('companyMechanicalCostVerification:audit')">
            <a-popconfirm title="是否确认修改" @confirm="audit(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">已确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#108ee9">已确认</a-tag>
          </span>
        </span>
        <span v-else>
          <span v-if="$auth('companyMechanicalCostVerification:audit')">
            <a-popconfirm title="是否确认修改" @confirm="audit(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">未确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#f50">未确认</a-tag>
          </span>
        </span>
      </span>
      <span slot="isAmount" slot-scope="text,record">
        <span v-if="String(text) === '1'">
          <!--          <a-tag color="#108ee9">已确认</a-tag>-->
          <span v-if="$auth('companyMechanicalCostVerification:isAmount')">
            <a-popconfirm title="是否确认修改" @confirm="isAmount(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">已确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#108ee9">已确认</a-tag>
          </span>
        </span>
        <span v-else>
          <span v-if="$auth('companyMechanicalCostVerification:isAmount')">
            <a-popconfirm title="是否确认修改" @confirm="isAmount(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">未确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#f50">未确认</a-tag>
          </span>
        </span>
      </span>
      <template slot="footer" style="float: right;">
        <span style="float: right; margin-right: 2%"><b>当前页合计费用金额：{{ totalAmount.toFixed(2) }} 元</b></span>
        <span style="float: right; margin-right: 5%"><b>总合计费用金额：{{ sumAmount.toFixed(2) }} 元</b></span>
        <br/>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { fetchList, download, audit, isAmount } from '@/api/statement/outMachine'
import { Ellipsis } from '@/components'

export default {
  name: 'OutMachineCost',
  mixins: [TableMixin],
  components: {
    Ellipsis
  },
  data () {
    return {
      totalAmount: 0.00, // 当前页的金额总和
      sumAmount: 0.00, // 满足当前查询条件的所有金额总和
      projectList: [], // 项目
      showable: false,
      clearDate: undefined,
      tableData: [],
      queryParam: {
        projectId: undefined,
        customerName: undefined,
        startTime: undefined,
        endTime: undefined,
        type: undefined,
        audit: undefined,
        isSum: true, // 用于标识是否需要求和
        isAmount: undefined
      },
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          this.sum(res.data)
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '客户名称',
          dataIndex: 'customerName',
          customRender: (text) => {
            return (
              <ellipsis length={30} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '机械类别',
          dataIndex: 'type',
          customRender: (text) => {
            return (
              <ellipsis length={20} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '单号',
          width: '120px',
          dataIndex: 'orderNumber',
          customRender: (text) => {
            return (
              text === null ? ' '
                : <ellipsis length={14} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '总工作时间',
          dataIndex: 'totalHour',
          customRender: (text, record) => {
            return (
              <div>
                { String(record.chargeMode) === '0' ? '1' : parseInt(String(text / 60.0)).toFixed(0) + '小时' + parseInt(String(text % 60)).toFixed(0) + '分钟(' +
                  (text / 60.00).toFixed(2) +
                  'h)'}
              </div>
            )
          }
        },
        {
          title: '单价',
          dataIndex: 'price',
          customRender: (text, record) => {
            return (
              <div style="float:right">
                {String(record.chargeMode) === '0' ? Number(record.amount).toFixed(3) : text === null ? ' 0.00 ' : Number(text).toFixed(3)}
              </div>
            )
          }
        },
        {
          title: '总金额',
          dataIndex: 'amount',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '日期',
          dataIndex: 'dailyDate',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        },
        {
          title: '确认审计',
          dataIndex: 'audit',
          width: '100px',
          scopedSlots: { customRender: 'audit' }
        },
        {
          title: '确认总金额',
          dataIndex: 'isAmount',
          width: '120px',
          scopedSlots: { customRender: 'isAmount' }
        }
      ]
    }
  },
  methods: {
    sum (data) {
      this.totalAmount = 0.00
      this.sumAmount = data.sumAmount
      data.records.map(da => {
        if (da.amount) {
          this.totalAmount += Number(da.amount)
        }
      })
    },
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropProjectList().then(res => {
        this.projectList = res.data
        this.queryParam.projectId = this.projectList[0].value
        this.queryPage()
      })
    },
    download () {
      download(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '外部机械成本统计.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    },
    // 审计
    audit (record) {
      audit(record).then(res => {
        this.$message.success('操作成功')
        this.queryPage()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    isAmount (record) {
      isAmount(record).then(res => {
        this.$message.success('操作成功')
        this.queryPage()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    }

  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
